import React from 'react';
import { Space, Button } from 'antd';
import { PlusOutlined, SearchOutlined, FilterOutlined } from '@ant-design/icons';

interface CaseActionsProps {
  onCreateCase: () => void;
  onSearch: () => void;
  onReset: () => void;
  loading?: boolean;
}

const CaseActions: React.FC<CaseActionsProps> = ({ onCreateCase, onSearch, onReset, loading }) => {
  return (
    <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between' }}>
      <Space>
        <Button type="primary" icon={<PlusOutlined />} onClick={onCreateCase}>
          新建案件
        </Button>
      </Space>
      <Space>
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={onSearch}
          loading={loading}
        >
          搜索
        </Button>
        <Button icon={<FilterOutlined />} onClick={onReset}>
          重置
        </Button>
      </Space>
    </div>
  );
};

export default CaseActions;
